import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=4c2a33e5&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=4c2a33e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a33e5",
  null
  
)

export default component.exports